<template>
  <div class="bg-secondary-3 border-radius--light py-3 px-4">
    <div class="row">
      <div class="col-md-4 border-right">
        <div class="mb-3">
          <em
            class="rounded-circle p-2 mr-2 color-primary-2 shadow bg-white"
            :class="icon"
          />
          <span>{{ label.main }}</span>
        </div>
        <custom-drop-down
          :custom-error-msg="errorMsgs.dd"
          fieldkey="id"
          fieldname="name"
          :label="label.dd"
          :options="deselected"
          placeholder="Seleccione"
          @input="selectItem"
        />
        <div class="row mt-3">
          <div class="col-md-8 text-left">
            <Link
              class="ml-n1"
              icon="fas fa-plus-circle"
              text="Seleccionar todas"
              @click="selectAll(true)"
            />
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-8">
            <custom-chips-group
              class="mt-n3"
              no-background
              :no-wrap="true"
              :object-text="'name'"
              :selected-items="selected"
              :title="label.selected"
              @itemMarkedForDeletion="unSelectItem"
            />
            <error
              v-if="showError"
              :message="errorMsgs.badge"
              variant="no-border"
            />
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-end">
            <action-button
              class="mr-3 w-15"
              i="fas fa-times-circle"
              text="Cerrar"
              variant="outline-danger"
              @click="$emit('onClose')"
            />
            <action-button
              class="w-15"
              i="fas fa-save"
              text="Guardar"
              variant="success"
              @click="save(selected)"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-4 col-md-3">
            <Link
              color="red"
              icon="fas fa-minus-circle"
              text="Eliminar todas"
              @click="selectAll(false)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from '@/components/common/form/CustomDropDown';
import ActionButton from '@/components/common/ActionButton';
import CustomChipsGroup from '@/components/common/CustomChipsGroup';
import Error from '@/components/common/Error';

export default {
  name: 'RolSelection',
  components: {
    CustomDropDown,
    ActionButton,
    CustomChipsGroup,
    Error,
  },
  props: {
    icon: {
      type: String,
      default: () => null,
    },
    errorMsgs: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: Object,
      default: () => ({}),
    },
    list: {
      type: Array,
      default: () => [],
    },
    showError: {
      type: Boolean,
      default: () => false,
    },
    save: {
      type: Function,
      default: () => () => {},
    },
  },
  data() {
    return {
      model: this.list,
    };
  },
  computed: {
    selected() {
      return this.model.filter((item) => item.selected);
    },
    deselected() {
      return this.model.filter((item) => !item.selected);
    },
  },
  watch: {
    list(value) {
      this.model = value;
    },
  },
  methods: {
    selectAll(value) {
      this.model.forEach((item) => (item.selected = value));
    },
    unSelectItem(item) {
      this.model.find((x) => x.id == item.id).selected = false;
    },
    selectItem(item) {
      this.model.find((x) => x.id == item.id).selected = true;
    },
  },
};
</script>
